import React from 'react';
import { TOURNAMENTS_LANDING_PAGE, TOURNAMENT_QUICK_CREATE_PAGE } from 'constants/pages';
import VictoryCupSimple from 'svg/VictoryCupSimple';
import { ButtonLink, ButtonLinkText } from 'components/Button';

const CardWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <div className="hidden h-full flex-col rounded-xl border border-color-border-input-lightmode p-6 shadow-[0px_4px_16px_0px_rgba(0,0,0,0.08)] dark:border-color-border-input-darkmode lg:flex">
        {children}
      </div>
    </>
  );
};

function CreateTournamentCard() {
  return (
    <>
      <CardWrapper>
        <h3 className="typography-product-heading-compact pb-4 text-center text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          Create your own tournament!
        </h3>
        <p className="typography-product-body px-4 pb-6 text-center text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          Create your tournament and enjoy Gameday!
        </p>
        <ButtonLink
          variant="brand"
          sizeDesktop="lg"
          sizeMobile="md"
          label="Create Round-robin"
          className="mb-8"
          iconLeft={<VictoryCupSimple className="h-5 w-5" />}
          href={TOURNAMENT_QUICK_CREATE_PAGE}
          isExternal
        />

        <ButtonLinkText
          href={TOURNAMENTS_LANDING_PAGE}
          className="typography-product-body-highlight text-center text-color-text-brand dark:text-color-text-brand"
          isExternal
        >
          More Info
        </ButtonLinkText>
      </CardWrapper>
    </>
  );
}

export default CreateTournamentCard;
